/**
 * useAuth — Thin wrapper around AuthContext.
 * Preserves the existing API so all 109+ consumers keep working
 * without any import changes.
 */
import { useAuthContext } from "@/contexts/AuthContext";

export function useAuth() {
  return useAuthContext();
}
